var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
var wrapLayer = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, null),
        React.createElement(Style, null, children)));
};
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    body {\n        overflow: hidden;\n    }\n"], ["\n    body {\n        overflow: hidden;\n    }\n"])));
var Style = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.6);\n    z-index: 110;\n    overflow:auto;\n    text-align: center;\n"], ["\n    position: fixed;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.6);\n    z-index: 110;\n    overflow:auto;\n    text-align: center;\n"])));
export default wrapLayer;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/wrap_layer.tsx
// module id = 289
// module chunks = 0